(function () {
  'use strict';

  var ROOT_SELECTOR = '[data-mjs-fd-popup]';
  var FOCUSABLE_SELECTOR = [
    'a[href]',
    'button:not([disabled])',
    'input:not([disabled])',
    'select:not([disabled])',
    'textarea:not([disabled])',
    '[tabindex]:not([tabindex="-1"])'
  ].join(',');
  var controllers = [];

  function normalisePath(value) {
    var path = (value || '/').replace(/\/+$/, '');
    return path || '/';
  }

  function isConversionCriticalPath(path) {
    return /^\/products(?:\/|$)/.test(path)
      || /^\/cart(?:\/|$)/.test(path)
      || /^\/checkout(?:s)?(?:\/|$)/.test(path)
      || /^\/account(?:\/|$)/.test(path)
      || /^\/orders?(?:\/|$)/.test(path)
      || /^\/password(?:\/|$)/.test(path)
      || /^\/challenge(?:\/|$)/.test(path);
  }

  function getCampaignPaths(root) {
    return (root.dataset.campaignPaths || '')
      .split(',')
      .map(function (item) { return normalisePath(item.trim()); })
      .filter(Boolean);
  }

  function isEligibleRoute(root) {
    var path = normalisePath(window.location.pathname);
    if (isConversionCriticalPath(path)) return false;
    if (root.dataset.routeScope === 'all_browsing') return true;
    return getCampaignPaths(root).indexOf(path) !== -1;
  }

  function isVisible(element) {
    if (!element) return false;
    var currentElement = element;

    while (currentElement) {
      if (currentElement.hidden || currentElement.getAttribute('aria-hidden') === 'true') return false;
      var style = window.getComputedStyle(currentElement);
      if (style.display === 'none' || style.visibility === 'hidden') return false;
      currentElement = currentElement.parentElement;
    }

    return true;
  }

  function initPopup(root) {
    if (!root || root.dataset.mjsFdInitialised === 'true') return null;
    root.dataset.mjsFdInitialised = 'true';

    if (root.dataset.enabled !== 'true' || !isEligibleRoute(root)) return null;

    document.documentElement.classList.add('mjs-fd-campaign-route');
    document.body.classList.add('mjs-fd-campaign-route');

    var dialog = root.querySelector('.mjs-fd-popup__dialog');
    var closeButton = root.querySelector('[data-mjs-fd-popup-close]');
    var cta = root.querySelector('[data-mjs-fd-popup-cta]');
    var delayMs = Math.max(0, Number(root.dataset.delaySeconds || 4) * 1000);
    var frequencyDays = Math.max(1, Number(root.dataset.frequencyDays || 1));
    var storageKey = root.dataset.storageKey || 'mjsFathersDayPopup:2026:v1';
    var lastFocused = null;
    var previousBodyOverflow = '';
    var openTimer = null;
    var retryCount = 0;
    var mutationObserver = null;
    var welcomeObservers = [];
    var suppressing = false;
    var scheduled = false;

    if (!dialog || !closeButton || !cta) return null;

    function readDismissedAt() {
      try {
        var raw = window.localStorage.getItem(storageKey);
        if (!raw) return 0;
        var parsed = JSON.parse(raw);
        return Number(parsed.dismissedAt || parsed.ts || 0);
      } catch (error) {
        return 0;
      }
    }

    function recordDismissal(reason) {
      try {
        window.localStorage.setItem(storageKey, JSON.stringify({
          dismissedAt: Date.now(),
          reason: reason || 'closed'
        }));
      } catch (error) {
        // Storage can be unavailable in strict privacy modes; closing still works.
      }
    }

    function isFrequencyCapped() {
      var dismissedAt = readDismissedAt();
      if (!dismissedAt) return false;
      return Date.now() - dismissedAt < frequencyDays * 24 * 60 * 60 * 1000;
    }

    function isForcedPreview() {
      var params = new URLSearchParams(window.location.search);
      return params.get('mjs_fd_popup') === '1'
        || !!(window.Shopify && window.Shopify.designMode);
    }

    function loadPopupMedia() {
      root.querySelectorAll('[data-mjs-fd-srcset]').forEach(function (element) {
        if (!element.getAttribute('srcset')) {
          element.setAttribute('srcset', element.dataset.mjsFdSrcset.trim());
        }
      });
      root.querySelectorAll('[data-mjs-fd-src]').forEach(function (element) {
        if (!element.dataset.mjsFdLoaded) {
          element.setAttribute('src', element.dataset.mjsFdSrc);
          element.dataset.mjsFdLoaded = 'true';
        }
      });
    }

    function getFocusableElements() {
      return Array.prototype.slice.call(dialog.querySelectorAll(FOCUSABLE_SELECTOR))
        .filter(isVisible);
    }

    function dispatch(name, detail) {
      root.dispatchEvent(new CustomEvent(name, {
        bubbles: true,
        detail: detail || {}
      }));
    }

    function popupIsOpen() {
      return !root.hidden && root.classList.contains('is-open');
    }

    function suppressCompetingPrompts() {
      if (suppressing) return;
      suppressing = true;
      var welcomeWasOpen = false;

      document.querySelectorAll('.mjs-nlp-overlay').forEach(function (element) {
        if (element.style.display !== 'none') {
          if (element.style.display) welcomeWasOpen = true;
          element.style.display = 'none';
        }
        if (element.getAttribute('aria-hidden') !== 'true') {
          element.setAttribute('aria-hidden', 'true');
        }
      });

      document.querySelectorAll('.mjs-nlp-teaser').forEach(function (element) {
        element.hidden = true;
        element.setAttribute('aria-expanded', 'false');
      });

      document.querySelectorAll('[data-testid="POPUP"], [data-testid="animated-teaser"], .klaviyo-close-form, [class*="kl-teaser-"], [data-kl-scroll-locking-modal="true"], [aria-label="POPUP Form"][role="dialog"]').forEach(function (element) {
        if (element.matches('[data-kl-scroll-locking-modal="true"], [aria-label="POPUP Form"][role="dialog"]') && element.style.display !== 'none') {
          element.style.display = 'none';
        }
        if (element.getAttribute('aria-hidden') !== 'true') {
          element.setAttribute('aria-hidden', 'true');
        }
      });

      document.body.classList.remove('klaviyo-prevent-body-scrolling');

      if (welcomeWasOpen && !popupIsOpen()) {
        document.body.style.overflow = '';
      }
      suppressing = false;
    }

    function observeWelcomeOverlay(element) {
      if (!element || element.dataset.mjsFdObserved === 'true') return;
      element.dataset.mjsFdObserved = 'true';
      var observer = new MutationObserver(suppressCompetingPrompts);
      observer.observe(element, {
        attributes: true,
        attributeFilter: ['style', 'aria-hidden']
      });
      welcomeObservers.push(observer);
    }

    function startMutualExclusion() {
      suppressCompetingPrompts();
      document.querySelectorAll('.mjs-nlp-overlay').forEach(observeWelcomeOverlay);
      mutationObserver = new MutationObserver(function () {
        document.querySelectorAll('.mjs-nlp-overlay').forEach(observeWelcomeOverlay);
        suppressCompetingPrompts();
      });
      mutationObserver.observe(document.body, { childList: true, subtree: true });
    }

    function anotherDialogIsOpen() {
      return Array.prototype.slice.call(document.querySelectorAll('[role="dialog"][aria-modal="true"]'))
        .some(function (element) {
          return element !== dialog && isVisible(element) && element.getAttribute('aria-hidden') !== 'true';
        });
    }

    function openPopup(force) {
      if (!force && isFrequencyCapped()) return false;
      if (popupIsOpen()) return true;

      suppressCompetingPrompts();
      if (anotherDialogIsOpen()) return false;
      loadPopupMedia();
      lastFocused = document.activeElement;
      previousBodyOverflow = document.body.style.overflow;
      root.hidden = false;
      root.setAttribute('aria-hidden', 'false');
      document.body.classList.add('mjs-fd-dialog-open');
      document.body.style.overflow = 'hidden';

      window.requestAnimationFrame(function () {
        root.classList.add('is-open');
        closeButton.focus({ preventScroll: true });
        window.setTimeout(function () {
          if (popupIsOpen() && !dialog.contains(document.activeElement)) {
            closeButton.focus({ preventScroll: true });
          }
        }, 220);
      });

      dispatch('mjs:fathers-day-popup:opened', { forced: !!force });
      return true;
    }

    function closePopup(reason, remember) {
      if (remember !== false) recordDismissal(reason);
      root.classList.remove('is-open');
      root.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('mjs-fd-dialog-open');
      document.body.style.overflow = previousBodyOverflow;

      window.setTimeout(function () {
        root.hidden = true;
        if (lastFocused && typeof lastFocused.focus === 'function' && document.contains(lastFocused)) {
          lastFocused.focus({ preventScroll: true });
        }
      }, 180);

      dispatch('mjs:fathers-day-popup:closed', { reason: reason || 'closed' });
    }

    function scheduleOpen() {
      if (scheduled) return;
      scheduled = true;
      if (!isForcedPreview() && isFrequencyCapped()) return;
      var delay = isForcedPreview() ? 200 : delayMs;

      openTimer = window.setTimeout(function attemptOpen() {
        var opened = openPopup(isForcedPreview());
        if (!opened && retryCount < 3) {
          retryCount += 1;
          openTimer = window.setTimeout(attemptOpen, 3000);
        }
      }, delay);
    }

    function handleKeydown(event) {
      if (!popupIsOpen()) return;
      if (event.key === 'Escape') {
        event.preventDefault();
        closePopup('escape');
        return;
      }
      if (event.key !== 'Tab') return;

      var focusable = getFocusableElements();
      if (!focusable.length) {
        event.preventDefault();
        dialog.focus();
        return;
      }

      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (!dialog.contains(document.activeElement)) {
        event.preventDefault();
        (event.shiftKey ? last : first).focus();
        return;
      }
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }

    function destroy() {
      if (openTimer) window.clearTimeout(openTimer);
      if (mutationObserver) mutationObserver.disconnect();
      welcomeObservers.forEach(function (observer) { observer.disconnect(); });
      document.removeEventListener('keydown', handleKeydown);
      document.body.classList.remove('mjs-fd-dialog-open');
      root.hidden = true;
      root.classList.remove('is-open');
    }

    closeButton.addEventListener('click', function () {
      closePopup('close_button');
    });

    cta.addEventListener('click', function () {
      recordDismissal('cta');
      dispatch('mjs:fathers-day-popup:cta', { href: cta.href });
    });

    root.addEventListener('click', function (event) {
      if (event.target === root) closePopup('backdrop');
    });
    document.addEventListener('keydown', handleKeydown);

    startMutualExclusion();
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', scheduleOpen, { once: true });
    } else {
      scheduleOpen();
    }

    return {
      root: root,
      open: function () { return openPopup(true); },
      close: function () { closePopup('manual'); },
      destroy: destroy
    };
  }

  function initialiseAll(scope) {
    (scope || document).querySelectorAll(ROOT_SELECTOR).forEach(function (root) {
      var controller = initPopup(root);
      if (controller) controllers.push(controller);
    });
  }

  initialiseAll(document);

  document.addEventListener('shopify:section:load', function (event) {
    initialiseAll(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    controllers = controllers.filter(function (controller) {
      if (event.target.contains(controller.root)) {
        controller.destroy();
        return false;
      }
      return true;
    });
  });

  window.MjsFathersDayPopup = {
    open: function () {
      return controllers.length ? controllers[0].open() : false;
    },
    close: function () {
      if (controllers.length) controllers[0].close();
    }
  };
})();
